var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.199341 8.63176V0.63176H8.19934V8.63176H0.199341ZM2.19934 6.63176H6.19934V2.63176H2.19934V6.63176ZM0.199341 18.6318V10.6318H8.19934V18.6318H0.199341ZM2.19934 16.6318H6.19934V12.6318H2.19934V16.6318ZM10.1993 8.63176V0.63176H18.1993V8.63176H10.1993ZM12.1993 6.63176H16.1993V2.63176H12.1993V6.63176ZM16.1993 18.6318V16.6318H18.1993V18.6318H16.1993ZM10.1993 12.6318V10.6318H12.1993V12.6318H10.1993ZM12.1993 14.6318V12.6318H14.1993V14.6318H12.1993ZM10.1993 16.6318V14.6318H12.1993V16.6318H10.1993ZM12.1993 18.6318V16.6318H14.1993V18.6318H12.1993ZM14.1993 16.6318V14.6318H16.1993V16.6318H14.1993ZM14.1993 12.6318V10.6318H16.1993V12.6318H14.1993ZM16.1993 14.6318V12.6318H18.1993V14.6318H16.1993Z",
    fill: "#0090D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr_code.fdc3ef446441fa0382c88f073608b9f1.svg";
export { ForwardRef as ReactComponent };